import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import 'parsleyjs';
import { loginUser } from '../../request';
import $ from "jquery";

const Login = (props) => {

    document.title = "Sign In";

    const dispatch = useDispatch();
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const [stateReady, setStateReady] = useState(false);

    $(function () {
        $('#login').parsley();

        return () => {
            $('#login').parsley().destroy();
        }
    });

    const handleSubmit = (e) => {
        e.preventDefault();

        const result = {
            id_number: $("id_number").val(),
            email: $("#email").val(),
            password: $("#password").val()
        };

        setStateReady(true);
        dispatch(loginUser(result)).then(() => {
            setStateReady(false);
        });
    };

    if(isAuthenticated) {props.history.push('/dashboard')}

    return (
        <div>
            <div className="content content-fixed content-auth">
                <div className="container">
                    <div className="media align-items-stretch justify-content-center ht-70p pos-relative">
                        <div className="sign-wrapper">
                            <div className="wd-100p">
                                <div className="text-center">
                                    <img src="assets/img/zlogo.png" className="ht-80 mg-b-20 img-fluid" alt="logo"/>
                                </div>
                                <h3 className="tx-color-01 text-center mg-b-10 tx-18">Teacher</h3>
                                <p className="tx-color-03 text-center tx-16 mg-b-40">Sign In to continue.</p>
                                <form id="login" className="parsley-style-1" data-parsley-validate="true" onSubmit={handleSubmit.bind()}>
                                    <div id="idWrapper" className="form-group parsley-input">
                                        <label>ID Number</label>
                                        <input id="id_number" type="text" className="form-control"
                                               placeholder="Enter ID Number"
                                               autoComplete="off"
                                               data-parsley-class-handler="#idWrapper" required/>
                                    </div>
                                    <div id="emailWrapper" className="form-group parsley-input">
                                        <label>Email address</label>
                                        <input id="email" type="email" className="form-control"
                                               placeholder="Enter your email address"
                                               autoComplete="off"
                                               data-parsley-class-handler="#emailWrapper" required/>
                                    </div>
                                    <div id="passwordWrapper" className="form-group parsley-input">
                                        <div className="mg-b-5">
                                            <label className="mg-b-0-f">Password</label>
                                        </div>
                                        <input id="password" type="password" className="form-control"
                                               placeholder="Enter your password"
                                               data-parsley-minlength="6"
                                               data-parsley-class-handler="#passwordWrapper" required/>
                                    </div>
                                    {stateReady ? <button className="btn btn-dark btn-block" disabled><span className="spinner-border spinner-border-sm mg-r-10" role="status" aria-hidden="true"/>Loading</button> : <button className="btn btn-dark btn-block">Sign In</button>}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Login;
